import { nanoid } from 'nanoid'
import * as oauth2 from 'oauth4webapi'

const sessionStorageAuthDataKey = 'authData'

type AuthData = {
    returnTo?: string
    codeVerifier: string
}

export const loadAuthData = (state: string): AuthData | null => {
    const data = window.sessionStorage.getItem(sessionStorageAuthDataKey)

    if (!data) {
        return null
    }

    const parsedData = JSON.parse(data)
    const authData = parsedData[state]
    delete parsedData[state]
    window.sessionStorage.setItem(sessionStorageAuthDataKey, JSON.stringify(parsedData))

    return authData
}

export const storeAuthData = async (returnTo?: string) => {
    const state = nanoid()
    const codeVerifier = oauth2.generateRandomCodeVerifier()

    if (!returnTo || new URL(returnTo).pathname === '/') {
        const storedReturnTo = window.sessionStorage.getItem('authReturnTo')
        if (storedReturnTo) {
            window.sessionStorage.removeItem('authReturnTo')
            returnTo = storedReturnTo
        }
    }

    const data = {
        returnTo: returnTo || null,
        codeVerifier,
    }

    const existingData = window.sessionStorage.getItem(sessionStorageAuthDataKey)
    if (existingData) {
        const parsedData = JSON.parse(existingData)
        parsedData[state] = data
        window.sessionStorage.setItem(sessionStorageAuthDataKey, JSON.stringify(parsedData))
    } else {
        window.sessionStorage.setItem(sessionStorageAuthDataKey, JSON.stringify({ [state]: data }))
    }

    const codeChallenge = await oauth2.calculatePKCECodeChallenge(codeVerifier)
    const codeChallengeMethod = 'S256'

    return {
        state,
        codeChallenge,
        codeChallengeMethod,
    }
}
